import { useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import { Button, Modal, ModalBody, Table } from "reactstrap";
import { Switch } from "antd";
import { FiImage } from "react-icons/fi";
import avatar from "../../assets/imgs/avatar-img.png";
import FormInput from "../formInput/FormInput";
import PdfSlipModal from "./PdfSlipModal";

const PackagingSlipModal = ({
  modal,
  toggle,
  line_items,
  setLineItems,
  state,
}) => {
  const [generatePdfModal, setGeneratePdfModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showLogo, setShowLogo] = useState(true);

  const handleQuantityChange = (index, newQuantity) => {
    const updatedItems = [...line_items];
    updatedItems[index].newQuantity = newQuantity;
    setLineItems(updatedItems);
  };

  const handleCheckboxChange = (index, row) => {
    const selectedIndex = selectedItems.findIndex(
      (item) => item.sku === row.sku
    );
    if (selectedIndex === -1) {
      setSelectedItems([...selectedItems, row]);
    } else {
      const updatedSelectedItems = [...selectedItems];
      updatedSelectedItems.splice(selectedIndex, 1);
      setSelectedItems(updatedSelectedItems);
    }
  };

  const allSelected = line_items?.length > 0 && selectedItems.length === line_items.length;
  const someSelected = selectedItems.length > 0 && selectedItems.length < (line_items?.length ?? 0);

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedItems([]);
    } else {
      setSelectedItems([...(line_items ?? [])]);
    }
  };

  const getQuantity = (sku, index) => {
    let totalQuantity = 0;
    const item = [...line_items];
    item[index]?.labels?.forEach((label) => {
      totalQuantity += label.quantity || 0;
    });
    return totalQuantity;
  };

  const togglePdfModal = () => setGeneratePdfModal(!generatePdfModal);

  return (
    <>
      {selectedItems?.length > 0 && (
        <PdfSlipModal
          modal={generatePdfModal}
          toggle={togglePdfModal}
          selectedItems={selectedItems}
          state={state}
          showLogo={showLogo}
          setShowLogo={setShowLogo}
        />
      )}

      <Modal isOpen={modal} toggle={toggle} centered size="xl">
        <ModalBody style={{ padding: "25px" }}>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3" style={{ borderBottom: "2px solid #e2e8f0", paddingBottom: "12px" }}>
            <div className="d-flex align-items-center gap-2">
              <div className="d-flex flex-column gap-1">
                <div style={{ width: "24px", height: "4px", backgroundColor: "#f0f0f0", borderRadius: "2px" }} />
                <div style={{ width: "24px", height: "4px", backgroundColor: "#dc2626", borderRadius: "2px" }} />
              </div>
              <h4 className="m-0 fw-bold" style={{ color: "#1a1a2e", letterSpacing: "0.3px" }}>Packing Slip</h4>
              {selectedItems?.length > 0 && (
                <span className="ms-2 px-2 py-1 rounded-pill" style={{ backgroundColor: "#fee2e2", color: "#dc2626", fontSize: "12px", fontWeight: 700 }}>
                  {selectedItems.length} selected
                </span>
              )}
            </div>
            <IoCloseSharp
              size={28}
              onClick={toggle}
              className="pointer"
              style={{ cursor: "pointer", color: "#6b7280" }}
            />
          </div>

          {/* Table */}
          <div className="pdf-container" style={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #e2e8f0", borderTop: "3px solid #dc2626" }}>
            <Table
              responsive
              bordered
              hover
              className="text-center mb-0"
              style={{ fontSize: "13px" }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f0f0f0", color: "#000" }}>
                  <th style={{ width: "60px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    <div className="d-flex flex-column align-items-center gap-1">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        style={{ width: "16px", height: "16px", cursor: "pointer", accentColor: "#fff" }}
                        checked={allSelected}
                        ref={(el) => { if (el) el.indeterminate = someSelected; }}
                        onChange={handleSelectAll}
                        title={allSelected ? "Deselect All" : "Select All"}
                      />
                      <span style={{ fontSize: "9px", lineHeight: 1 }}>All</span>
                    </div>
                  </th>
                  <th style={{ width: "70px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Image</th>
                  <th style={{ width: "120px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>SKU</th>
                  <th style={{ width: "220px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "left" }}>Description</th>
                  <th style={{ width: "90px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Part</th>
                  <th style={{ width: "80px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Weight</th>
                  <th style={{ width: "70px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Qty</th>
                  <th style={{ width: "120px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Ship Qty</th>
                  <th style={{ width: "120px", padding: "10px 8px", fontWeight: 600, fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>Shipped</th>
                </tr>
              </thead>

              <tbody>
                {line_items?.map((row, index) => {
                  const isSelected = selectedItems.some((item) => item.sku === row.sku);
                  return (
                    <tr
                      key={index}
                      className="align-middle"
                      style={{
                        backgroundColor: isSelected ? "#f9fafb" : index % 2 === 0 ? "#fff" : "#f8fafc",
                        borderLeft: isSelected ? "3px solid #f0f0f0" : "3px solid transparent",

                        transition: "background-color 0.15s ease",
                      }}
                    >
                      <td style={{ padding: "8px" }}>
                        <input
                          type="checkbox"
                          className="form-check-input"
                          style={{ width: "16px", height: "16px", cursor: "pointer" }}
                          checked={isSelected}
                          onChange={() => handleCheckboxChange(index, row)}
                        />
                      </td>

                      <td style={{ padding: "8px" }}>
                        <img
                          src={row?.image?.src ?? avatar}
                          height={36}
                          width={36}
                          className="rounded"
                          style={{ objectFit: "cover", border: "1px solid #e2e8f0" }}
                          alt="product"
                        />
                      </td>

                      <td style={{ fontWeight: 600, color: "#1e293b", padding: "8px" }}>{row?.sku}</td>

                      <td style={{ textAlign: "left", padding: "8px", }}>
                        {row?.description?.slice(0, 40) ?? "Not Available"}...
                      </td>

                      <td style={{ padding: "8px", }}>{row?.sku?.slice(4) ?? 0}</td>

                      <td style={{ padding: "8px", }}>{row?.weight ?? 0}</td>

                      <td style={{ padding: "8px" }}>
                        <span style={{ backgroundColor: "#f3f4f6", color: "#4b5563", fontWeight: 700, padding: "2px 10px", borderRadius: "12px", fontSize: "12px" }}>
                          {row?.quantity}
                        </span>
                      </td>

                      <td style={{ width: "120px", padding: "8px" }}>
                        <FormInput
                          size={"small"}
                          type={"number"}
                          className={"w-75 text-center"}
                          value={row.newQuantity ?? 0}
                          handleChange={(e) => {
                            if (
                              e.target.value > row?.quantity ||
                              e.target.value < 0
                            ) {
                              return;
                            }
                            handleQuantityChange(index, parseInt(e.target.value));
                          }}
                        />
                      </td>

                      <td style={{ fontWeight: 600, color: "#059669", padding: "8px" }}>
                        {getQuantity(row?.sku, index)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          {/* Footer */}
          <div className="d-flex justify-content-between align-items-center mt-3 pt-3" style={{ borderTop: "1px solid #e2e8f0" }}>
            <div className="d-flex align-items-center gap-4">
              <p className="mb-0 text-muted" style={{ fontSize: "13px" }}>
                {line_items?.length ?? 0} item{line_items?.length !== 1 ? "s" : ""} total
              </p>
              <div
                className="d-flex align-items-center gap-2 px-3 py-1 bg-light rounded-pill border"
                style={{ fontSize: "13px" }}
              >
                <FiImage size={14} className={showLogo ? "text-primary" : "text-muted"} />
                <span className="text-secondary fw-semibold" style={{ fontSize: "12px" }}>
                  Include Logo:
                </span>
                <Switch
                  checked={showLogo}
                  onChange={(checked) => setShowLogo(checked)}
                  size="small"
                  checkedChildren="ON"
                  unCheckedChildren="OFF"
                />
              </div>
            </div>
            <Button
              className="border-0 px-4 py-2 fw-semibold d-flex align-items-center gap-2"
              disabled={selectedItems.length === 0}
              onClick={togglePdfModal}
              style={{
                backgroundColor: selectedItems.length === 0 ? "#94a3b8" : "#4b5563",
                color: "#fff",
                borderRadius: "6px",
                fontSize: "14px",
                letterSpacing: "0.3px",
                opacity: selectedItems.length === 0 ? 0.7 : 1,
                cursor: selectedItems.length === 0 ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
              }}
            >
              Generate Packing Slip
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PackagingSlipModal;
